// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from "./router";
import store from "./store";
import animated from 'animate.css' // npm install animate.css --save安装，在引入
import "@/assets/css/base.css";
import { Button, message,Menu,Icon,Row,Col,Badge,Tabs,Carousel,List,Input,InputNumber} from 'ant-design-vue';
import "lib-flexible/flexible";

// 查看大图 begin
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
// 查看大图 end

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2663242_hj7gq6jv08.js',
});
Vue.use(animated)
Vue.config.productionTip = false
/* v1.1.3+ 自动注册Button下组件，如Button.Group */
Vue.use(Button).use(Menu).use(Icon).use(Icon).use(Row).use(Col).use(Badge).use(Tabs).use(Carousel).use(List).use(Input).use(InputNumber);
Vue.component('icon-font', IconFont );
Vue.prototype.$message = message;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js